<template>
  <div class="timer-controller">
    <div class="counter-title">
      <img src="../assets/tool-logo.png" alt="counter">
    </div>
    <div class="timer-btn-area">
      <button @click="startTimer" class="timer-btn btn--orange">Start</button>
      <button @click="stopTimer" class="timer-btn btn--orange">Stop</button>
      <button @click="resetTimer" class="timer-btn btn--stone">Reset</button>
      <button @click="startFromMinusThree" class="timer-btn btn--orange">Start from -3</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: null,
      seconds: 0
    }
  },
  methods: {
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(this.incrementTime, 1000);
        localStorage.setItem('timerRunning', 'true');
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      localStorage.setItem('timerRunning', 'false');
    },
    resetTimer() {
      this.stopTimer();
      this.seconds = 0;
      localStorage.setItem('timerSeconds', '0');
    },
    startFromMinusThree() {
      this.resetTimer();
      this.seconds = -3;
      localStorage.setItem('timerSeconds', '-3');
      this.startTimer();
    },
    incrementTime() {
      this.seconds++;
      localStorage.setItem('timerSeconds', this.seconds.toString());
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
</script>

<style scoped>
.timer-controller {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #fccf98;
  height: 100vh;
}


.buttons button {
  margin: 0 5px;
}
.timer-btn-area{
  margin-top:12px;
}

.timer-btn{
  margin: 3px 3px;
  padding:3px 12px;
  border-radius: 5px;
  appearance: none;
  border: 0;
  letter-spacing: 0.12em;
  color: #fff;
  cursor : pointer;
}

.btn--orange {
  background-color: #eb6100;
}
.btn--orange:hover{
  background: #f56500;
}

.btn--stone {
  background-color: #57534e;
}
.btn--stone:hover{
  background: #78716c;
}
</style>